import pick from 'lodash/pick'

export default class {

  constructor ({
                 data,
                 label,
                 fill = false,
                 borderColor = '#000',
                 backgroundColor = '#000',
                 borderCapStyle = 'butt',
                 borderJoinStyle = 'miter',
                 lineTension = 0,
                 pointRadius = 2,
                 borderWidth = 2,
                 pointBorderWidth = 5,
                 pointHoverRadius = 3,
                 pointBackgroundColor = '#000',
                 pointBorderColor = '#000',
                 pointStyle = 'rect',
                 type = 'line',
                 borderDash = []
               }) {

    this.data = data
    this.label = label
    this.fill = fill
    this.borderColor = borderColor
    this.backgroundColor = backgroundColor
    this.borderCapStyle = borderCapStyle
    this.borderJoinStyle = borderJoinStyle
    this.lineTension = lineTension
    this.pointRadius = pointRadius
    this.borderWidth = borderWidth
    this.pointBorderWidth = pointBorderWidth
    this.pointHoverRadius = pointHoverRadius
    this.pointBackgroundColor = pointBackgroundColor
    this.pointBorderColor = pointBorderColor
    this.pointStyle = pointStyle
    this.type = type
    this.borderDash = borderDash

  }
}



// WEBPACK FOOTER //
// ./src/common/chart/Component/LineChartDataset.js